export const darkTheme = {
    mode: "dark",
    colors: {
        background: "#0B1114",
        text: "#EAEAEA",
        muted: "#999999",
        primary: "#4C8DFF",
    },
};
